<section class="landing" *ngIf="!data.muestra.muestraId">
  <div class="landing__header"><img src="assets/images/brand-mobile.svg" alt=""></div>
  <div class="landing__content">
    <h2>Bienvenido al Laboratorio de Lubricantes de COPEC</h2>
  </div>
  <div class="landing__footer"><img src="assets/images/brand-copec.svg" alt=""></div>
</section>

<reportExportPDF *ngIf="data.muestra.muestraId" [sample]="data.muestra" #report_muestra></reportExportPDF>